import React, { useEffect, useState } from 'react';
import List from 'devextreme-react/list.js';
import { useNavigate } from 'react-router-dom';
import { navigation } from './DrawerNavigationData.js';
import { useAuthentication } from './LoginPage';
import * as Store from '@apply/store';

export interface DrawerNavigationList {}

export const DrawerNavigationList: React.FC<DrawerNavigationList> = () => {
    const { isFeatureEnabled } = useAuthentication();
    const navigate = useNavigate();
    const [activeNavigation, setActiveNavigation] = useState([]);
    const handleItemClick = (e) => {
        navigate(e.itemData.navigateUrl);
    };

    useEffect(() => {
        const auth = Store.UserStore.Types.retrieve();
        if (auth?.user) {
            setActiveNavigation(navigation.filter((item) => item.featureFlag == null || isFeatureEnabled(item.featureFlag)));
        }
    }, []);

    return (
        /* Width will need to be adjusted as items are added - 200px should be max */
        <div
            className='list'
            style={{ width: '200px' }}
        >
            <List
                dataSource={activeNavigation}
                hoverStateEnabled={false}
                activeStateEnabled={false}
                focusStateEnabled={false}
                className='panel-list'
                onItemClick={handleItemClick}
            />
        </div>
    );
};
